import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import styled from 'styled-components';
import TikTokLogo from 'assets/TikTokBanner/tiktok-logo.png';
import { isTikTokBrowser } from 'utils/isTikTokBrowser';
/**
 * Checks if the current device is running Android
 */
function isAndroid() {
    if (typeof navigator === 'undefined')
        return false;
    return /android/i.test(navigator.userAgent);
}
const messages = defineMessages({
    tiktok_help_title: 'Hey TikTokers!',
    tiktok_help_question: 'Is the button at the top not working?',
    tiktok_help_hint: 'Tap and hold for 2 sec to open the link',
    tiktok_help_cta: 'Tap and hold',
});
const TikTokBanner = ({ deeplink, onClick }) => {
    // Start with false to match server render, then update on client
    const [isVisible, setIsVisible] = useState(false);
    useEffect(() => {
        // Show TikTok banner only on non-Android devices (iOS, etc.)
        setIsVisible(isTikTokBrowser() && !isAndroid());
    }, []);
    if (!isVisible)
        return null;
    return (_jsxs(Card, { children: [_jsx(LogoWrapper, { children: _jsx(Logo, { src: TikTokLogo, alt: "TikTok" }) }), _jsxs(Content, { children: [_jsxs(Title, { children: [_jsx(TitleHighlight, { children: _jsx(FormattedMessage, Object.assign({}, messages.tiktok_help_title)) }), ' ', _jsx(FormattedMessage, Object.assign({}, messages.tiktok_help_question))] }), _jsx(Hint, { children: _jsx(FormattedMessage, Object.assign({}, messages.tiktok_help_hint)) })] }), _jsxs(CTA, { href: deeplink, onClick: onClick, children: [_jsx(FormattedMessage, Object.assign({}, messages.tiktok_help_cta)), _jsx(ArrowIcon, {})] })] }));
};
const m = '1260px';
const Card = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-top: 20px;
  padding: 20px;
  width: 260px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
  position: relative;

  @media (min-width: ${m}) {
    display: none;
  }
`;
const LogoWrapper = styled.div `
  position: absolute;
  right: -10px;
  top: -20px;
  transform: rotate(-8deg);
`;
const Logo = styled.img `
  width: 47px;
  height: 47px;
  border-radius: 12px;
`;
const Content = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  text-align: center;
`;
const Title = styled.h3 `
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 1.2;
  margin: 0;
  color: #ffffff;
  letter-spacing: -0.14px;
`;
const TitleHighlight = styled.span `
  color: #7ed6e4;
`;
const Hint = styled.p `
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.2;
  letter-spacing: -0.12px;
  color: #ffffff;
  margin: 0;
`;
const CTA = styled.a `
  font-family: 'Inter', sans-serif;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 100px;
  background: #ffffff;
  color: #0f0f0f;
  text-decoration: none;
  font-size: 14px;
  line-height: 1.2;
  font-weight: 700;
  letter-spacing: -0.14px;
`;
const ArrowIcon = styled.div `
  width: 16px;
  height: 16px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'%3E%3Cpath d='M4.5 11.5L11.5 4.5M11.5 4.5H5.5M11.5 4.5V10.5' stroke='%230F0F0F' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-size: contain;
  background-repeat: no-repeat;
`;
export default TikTokBanner;
